<template>
	<db-col height="auto" width="auto" class="error-message-wrapper" :class="'align--' + align" valign="middle" v-if="show" :style="style" @click="clearMessage">
		{{value}}
		<db-icon icon="close-o" size="24" width="16" height="24" />
	</db-col>
</template>

<script>
	export default {
		props: {
			value: {
				type: String,
				default: ''
			},
			
			align: {
				type: String,
				default: ''
			}
		},
		
		data(){
			return {
				show: false,
				style: {
					opacity: 0,
					transform: 'translateX(20px)'
				}
			}
		},
		
		watch: {
			value(val){
				console.log('watchval', val)
				if(val){
					this.showMessage()
				}else{
					this.clearMessage()
				}
			}
		},
		
		methods: {
			showMessage(){
				this.show = true
				setTimeout(() => {
					Object.assign(this.style, {
						opacity: 1.0,
						transform: 'translateX(0)'
					})
				}, 100)
			},
			
			clearMessage(){
				Object.assign(this.style, {
					opacity: 0,
					transform: 'translateX(20px)'
				})
				setTimeout(() => {
					this.show = false
					this.$emit('input', '')
				}, 300)
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.error-message-wrapper{
		position: absolute;
		border-radius: 6px;
		background: #FFCCCC;
		color: #FF0000;
		font-size: 24px;
		transition: all .3s;
		max-width: 90%;
		padding: 10px 12px;
		
		.h5-icon-close-o{
			margin-left: 8px;
		}
		
		&.align--right{
			right: 10px;
			
			&::before{
				content: '';
				position: absolute;
				top: 50%;
				right: -18px;
				width: 0;
				height: 0;
				border: solid 10px transparent;
				border-left-color: #FFCCCC;
				margin-top: -10px;
			}
		}
		
		&.align--left{
			left: 10px;
			
			&::before{
				content: '';
				position: absolute;
				top: 50%;
				left: -18px;
				width: 0;
				height: 0;
				border: solid 10px transparent;
				border-right-color: #FFCCCC;
				margin-top: -10px;
			}
		}
	}
</style>
